import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "babel-polyfill";
import React from "react";
import RootRouter from "./root-router";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import store from "./store";
import "./sagas";
import { createRoot } from 'react-dom/client';

const container = document.getElementById("root");
const root = createRoot(container); 
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <RootRouter />
    </BrowserRouter>
  </Provider>
);